import { Matrix, mseDerivate, sigmoid, sigmoidDerivate } from './Math'


export class Layer {

	
	constructor(nNeurons, nPrevNeurons) {
		this.neurons = []
		this.weights = []
		this.bias = []
		this.deltas = []	
		this.init(nNeurons, nPrevNeurons)
	}


	init(rows, cols) {
		Matrix.init(this.weights, rows, cols)
		for (let row = 0; row < rows; row++) {
			this.neurons[row] = 0.0
			this.bias[row] = Math.random() - 0.5
		}
	}


	activateNeurons(input) {
		Matrix.multiply(this.weights, input, this.neurons)
		for (let i = 0; i < this.neurons.length; i++) {
			this.neurons[i] = sigmoid(this.neurons[i] + this.bias[i])
		}
	}	


	computeOutputDeltas(target) {
		for (let i = 0; i < this.neurons.length; i++) {
			this.deltas[i] = mseDerivate(this.neurons[i], target[i])
		}
	}


	computeHiddenDeltas(nextLayer) {
		Matrix.multiplyR(nextLayer.deltas, nextLayer.weights, this.deltas)
		for (let i = 0; i < this.deltas.length; i++) {
			this.deltas[i] = sigmoidDerivate(this.neurons[i]) * this.deltas[i]
		}
	}

	gradientDescent(prevLayer, learningRate) {
		for (let i = 0; i < this.neurons.length; i++) {
			this.bias[i] -= learningRate * this.deltas[i];
			for (let j = 0; j < prevLayer.neurons.length; j++) {
				this.weights[i][j] -= learningRate * this.deltas[i] * prevLayer.neurons[j]
			}
		}
	}


}

